import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

import type { AppState } from '@jane/monolith/customer/redux';

export type ModalNames = 'cartAlerts' | 'login' | 'logout' | 'replaceCart';

type ModalParams<Name extends ModalNames> = {
  name: Name;
};

type OpenModalPayload =
  | ModalParams<'cartAlerts'>
  | ModalParams<'login'>
  | ModalParams<'logout'>
  | ModalParams<'replaceCart'>;

export type ModalState = {
  modalName: ModalNames | null;
};

const getInitialState = (): ModalState => ({
  modalName: null,
});

const modalSlice = createSlice({
  name: 'modal',
  initialState: getInitialState(),
  reducers: {
    openModal: (state, action: PayloadAction<OpenModalPayload>) => {
      const { name } = action.payload;
      return { ...state, modalName: name };
    },
    closeModal: (state) => {
      return { ...state, modalName: null };
    },
  },
});

export const {
  reducer: modalReducer,
  actions: { closeModal, openModal },
} = modalSlice;

export type ModalActions =
  ReturnType<typeof closeModal> | ReturnType<typeof openModal>;

export const selectModal = createSelector(
  [(state: AppState) => state.modal],
  (modalState): ModalState & { isModalOpen: boolean } => {
    return {
      ...modalState,
      isModalOpen: !!modalState.modalName,
    };
  }
);
